import { ItemType, OrderLineRefundStatus } from '@vista-digital/ocapi-types/v1';
import { addMonetaryValues, subtractMonetaryValues } from '../../../utils/monetary-value-utils';
import { getOrderRelatedShowtimeById } from '../../order/selectors/showtimes/get-order-related-showtime-by-id';
import { getRefundedOrderTicketLinesForShowtime } from '../../order/utils/order-showtime-utils';
import { getTicketCountOfTicketLines } from '../../order/utils/tickets/order-ticket-line-utils';
import { sortOrderShowtimes } from './journey-order-showtime-utils';
export const getAllOrderItemsInJourney = (journey) => {
    return journey.orders.reduce((acc, order) => [...acc, ...order.items], []);
};
export const getAllNonRefundedOrderItemsInJourney = (journey) => {
    return getAllOrderItemsInJourney(journey).filter(o => o.refundStatus === OrderLineRefundStatus.NotRefunded);
};
export const getAllOrderShowtimesInJourney = (journey) => {
    return journey.orders.reduce((acc, order) => [...acc, ...order.showtimes], []);
};
export const getAllOrderTicketLinesInJourney = (journey) => {
    const showtimes = getAllOrderShowtimesInJourney(journey);
    return showtimes.reduce((acc, showtime) => [...acc, ...showtime.tickets], []);
};
export const getSortedJourneyOrderShowtimes = (journey) => {
    const showtimes = getAllOrderShowtimesInJourney(journey);
    return sortOrderShowtimes(showtimes);
};
export const getTotalBookingFeeForJourney = (journey) => addMonetaryValues(...journey.orders.map(order => { var _a; return (_a = order.booking) === null || _a === void 0 ? void 0 : _a.totalBookingFee; }));
export const getSubtotalCostOfJourney = (journey) => {
    const totalCost = getTotalCostOfJourney(journey);
    const bookingFee = getTotalBookingFeeForJourney(journey);
    return subtractMonetaryValues(totalCost, bookingFee);
};
export const getTotalCostOfJourney = (journey) => addMonetaryValues(...journey.orders.map(order => order.totalPrice));
export const isOrderNormalItem = (orderItem) => {
    return orderItem.type === ItemType.Normal;
};
export const getAllNonRefundedTicketsInJourney = (journey) => {
    return getAllOrderTicketLinesInJourney(journey).filter(t => t.refundStatus === OrderLineRefundStatus.NotRefunded);
};
export const getTotalNonRefundedTicketCountForJourney = (journey) => {
    const ticketLines = getAllNonRefundedTicketsInJourney(journey);
    return getTicketCountOfTicketLines(ticketLines);
};
export const getTotalTicketCountForJourney = (journey) => {
    const showtimes = getAllOrderShowtimesInJourney(journey);
    const ticketLines = showtimes.reduce((acc, showtime) => [...acc, ...showtime.tickets], []);
    return getTicketCountOfTicketLines(ticketLines);
};
export const getNextOrderShowtimeForJourney = (journey) => {
    const sortedJourneyShowtimes = getSortedJourneyOrderShowtimes(journey);
    if (!sortedJourneyShowtimes.length)
        return;
    return sortedJourneyShowtimes[0];
};
export const getNextShowtimeForJourney = (journey) => {
    var _a;
    const nextOrderShowtimeId = (_a = getNextOrderShowtimeForJourney(journey)) === null || _a === void 0 ? void 0 : _a.showtimeId;
    if (!nextOrderShowtimeId)
        return;
    return getOrderRelatedShowtimeById(nextOrderShowtimeId);
};
export const getTotalSavingsOfJourney = (journey) => addMonetaryValues(...journey.orders.map(order => order.amountSaved));
/**
 * Gets a list of OrderShowtimes with tickets that have been refunded.
 * @param journey
 */
export const getOrderShowtimesWithRefundsInJourney = (journey) => {
    return getAllOrderShowtimesInJourney(journey).reduce((acc, orderShowtime) => {
        const refundedTicketLines = getRefundedOrderTicketLinesForShowtime(orderShowtime);
        if (!refundedTicketLines.length)
            return [...acc];
        const refundedOrderShowtime = Object.assign(Object.assign({}, orderShowtime), { tickets: refundedTicketLines });
        return [...acc, refundedOrderShowtime];
    }, []);
};
